// Reselect Selector
// this selector parses state.stripeCustomer to extract a
// default card object
// {
//   id: 'card_1CsYKmL2vzJWjV5GKs7pgfS2',
//   object: 'card',
//   exp_month: 8,
//   exp_year: 2018,
//   last4: '4242',
//   ...
// }

import _ from 'lodash';
import { createSelector } from 'reselect';

// state selecting function
const customer = state => state.stripeCustomer;

// get default card
const getDefaultCard = myCustomer => {
  if (myCustomer.sources) {
    return _.find(myCustomer.sources.data, { object: 'card' });
  }
  return null;
};

export default createSelector(customer, getDefaultCard);



// WEBPACK FOOTER //
// ./src/selectors/StripeDefaultCardSelector.js